/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UpdateCommissionRateRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CommissionRateMassUpdates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name UpdateCommissionRate
   * @request POST:/commissionRate-mass-updates
   * @secure
   */
  updateCommissionRate = (data: UpdateCommissionRateRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commissionRate-mass-updates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCommissionRateMassUpdates
   * @request OPTIONS:/commissionRate-mass-updates
   */
  optionsCommissionRateMassUpdates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commissionRate-mass-updates`,
      method: 'OPTIONS',
      ...params,
    });
}
